/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".spinner[_ngcontent-%COMP%]{height:100%;width:100%;background-color:#ddd;opacity:.6;position:fixed;z-index:99999999;top:0;left:0}.spinner[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{margin-top:auto;margin-bottom:auto}"];
export { styles as styles };
